"use strict";

exports.__esModule = true;
exports.Logbook = void 0;
var _react = _interopRequireDefault(require("react"));
var _Core = require("../Core");
var _LogbookContext = require("./LogbookContext");
var _LogbookPanel = require("./LogbookPanel");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Logbook = exports.Logbook = function Logbook(props) {
  var width = props.width,
    height = props.height,
    onClick = props.onClick;
  var logbook = _react["default"].useContext(_LogbookContext.LogbookContext);
  return /*#__PURE__*/_react["default"].createElement(_Core.AsyncLoader, {
    load: function load() {
      return logbook.getLogbookData();
    }
  }, function (_ref) {
    var loaded = _ref.loaded,
      reload = _ref.reload,
      fetching = _ref.fetching,
      error = _ref.error;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, loaded && /*#__PURE__*/_react["default"].createElement(_LogbookPanel.LogbookPanel, {
      logbook: logbook,
      width: width,
      height: height,
      onClick: onClick,
      reload: reload
    }), fetching && /*#__PURE__*/_react["default"].createElement(_Core.Spinner, null), error && /*#__PURE__*/_react["default"].createElement(_Core.UhOh, {
      error: error
    }));
  });
};